const tab_sections = {
    overview: '개요',
    authentication: '인증',
    authorization: '인가',
    users: '사용자',
    developer: '개발자',
    tenant: '임차인',
};
export default Object.freeze(tab_sections);
